/* eslint-disable */
import fetch from "./fetch";
const graphServerUrl = process.env.NODE_ENV == 'production' ? 'https://prod-popvip.paquapp.com' : 'https://beta-popvip.paquapp.com'
const alipayServerUrl = process.env.NODE_ENV == 'production' ? 'https://alipaybox.paquapp.com' : 'https://alipaybox-dev.paquapp.com'
const jsonUrl = process.env.VUE_APP_JSON_URL
const T = new Date().getTime()
export default {
  getWxCode(url) {
    return fetch({
      method: "GET",
      url: "/v2/vipclub/jsapi/config",
      params: {
        url: url
      }
    });
  },
  //获取用户所有信息
  getPopMartInfo(userID) {
    return fetch({
      method: "GET",
      url: "/v2/annual/bill/2020",
      params: {
        user_id: userID
      }
    });
  },
  //newYear：抽一盒：抽取年度账单祝福语接口
  getBillGreeting(popmart_id) {
    return fetch({
      method: "GET",
      url: "/v2/annual/bill/greeting?popmart_id=" + popmart_id
    });
  },
  //coupon：获取优惠券
  getBillCoupon(user_id) {
    return fetch({
      method: "GET",
      url: "/v2/annual/bill/coupon?user_id=" + user_id
    });
  },
  getUrlBlob(url) {
    return fetch({
      method: "GET",
      url: '/v2/annual/bill/image?url=' + url
    })
  },
  getArticleID(){
    return fetch({
      method: "GET",
      url: '/v2/activity/current'
    })
  },
  getMemberDayBg(){
    return fetch({
      method: "GET",
      url: '/v2/activity/activity_article'
    })
  },
  getActivityRule(game_id){
    return fetch({
      method: "GET",
      url: '/v2/question_game/rules?game_id=' + game_id
    })
  },
  getCardRule(data, headers){
    return fetch({
      method: "POST",
      url: graphServerUrl + '/activity/v1/activity/activities/public-info',
      data: data,
      headers: headers
    })
  },
  getShotPhotoConfig(){
    const isDev = process.env.NODE_ENV !== 'production';
    return fetch({
      method: 'GET',
      url: `${jsonUrl}shot_photo_config/${isDev ? "shot_photo_config_test.json" : "shot_photo_config.json"}?_t=${T}`
    })
  },
  getAlipayOrderPhoto(params){
    return fetch({
      method: 'GET',
      url: `${alipayServerUrl}/orderserver/v1/order/getOrderSnapshot`,
      params
    })
  }
};

